import apiHelper from "./apiHelper"
import { API_ROUTES } from "../utils/constants"

export function createBannerBot(data) {
    return apiHelper({ method: "post", path: API_ROUTES.BANNER_BOT.CREATE, data })
}
export function editBannerBot(data) {
    return apiHelper({ method: "post", path: API_ROUTES.BANNER_BOT.EDIT, data })
}

export function connectBannerBot(botId) {
    return apiHelper({ method: "post", path: API_ROUTES.BANNER_BOT.CONNECT, data: { botId } })
}

export function disconnectBannerBot(botId) {
    return apiHelper({ method: "post", path: API_ROUTES.BANNER_BOT.DISCONNECT, data: { botId } })
}

export function reconnectBannerBot(botId) {
    return apiHelper({ method: "post", path: API_ROUTES.BANNER_BOT.RECONNECT, data: { botId } })
}

export function extendBannerBot(botId) {
    return apiHelper({ method: "post", path: API_ROUTES.BANNER_BOT.EXTEND, data: { botId } })
}

export function deleteBannerBot(botId) {
    return apiHelper({ method: "post", path: API_ROUTES.BANNER_BOT.DELETE, data: { botId } })
}

export function activateBannerBot(botId) {
    return apiHelper({ method: "post", path: API_ROUTES.BANNER_BOT.ACTIVATE, data: { botId } })
}

export function suspendBannerBot(botId) {
    return apiHelper({ method: "post", path: API_ROUTES.BANNER_BOT.SUSPEND, data: { botId } })
}

export function startAllBannerBots(selecteds) {
    return apiHelper({ method: "post", path: API_ROUTES.BANNER_BOT.CONNECT_BULK, data: { selecteds } })
}

export function stopAllBannerBots(selecteds) {
    return apiHelper({ method: "post", path: API_ROUTES.BANNER_BOT.DISCONNECT_BULK, data: { selecteds } })
}

export function restartAllBannerBots(selecteds) {
    return apiHelper({ method: "post", path: API_ROUTES.BANNER_BOT.RECONNECT_BULK, data: { selecteds } })
}

export function generateTokenForBannerPanel(botId) {
    return apiHelper({ method: "post", path: API_ROUTES.BANNER_BOT.GENERATE_TOKEN_FOR_BANNER_PANEL, data: { botId } })
}

export function getDeleteCalculation(botId) {
    return apiHelper({ method: "post", path: API_ROUTES.BANNER_BOT.GET_DELETE_CALCULATION, data: { botId } })
}

export function getExtendCalculation(botId) {
    return apiHelper({ method: "post", path: API_ROUTES.BANNER_BOT.GET_EXTEND_CALCULATION, data: { botId } })
}
